const Portfolio_data = [
  {
    id: 1,
    category: "React",
    totalLike: "600",
    title: "Clone of Indian Express.",
    image: "https://i.postimg.cc/d12LGKB4/Screenshot-2022-08-03-152004.png",
    overview:"This project is a functional clone of the original Indian Express website.At a time when India was struggling for her freedom, oppression was rife and the press virtually gagged, one voice dared to break the silence. Founded by Shri Ramnath Goenka in 1932, The Indian Express gave India a voice of opinion that was fearless and true.",
    desc : "The clone was made using HTML5, CSS3 , and JavaScript and frameworked using React. The clone has sign in and login functionality. Most of the news categories was built for the project by my team members. The top and bottom Navigation bar along with login and signup functionality was built by me for the project. I have made it responsive as well.",
    deployed_link: "https://indianexpressclone.netlify.app/",
    github: "https://github.com/J-Prajwal/indianExpress",
  },
  {
    id: 2,
    category: "React",
    totalLike: "750",
    title: "Google Timer and Stopwatch",
    image: "https://i.postimg.cc/26jv26KV/Screenshot-2022-08-03-154704.png",
    overview:"This app is a functional clone of the Google timer and google stopwatch",
    desc : "This works similar to google timer and stopwatch, but it do not take input time from user for timer. You can switch between timer and stopwatch. You can also stop, pause and reset the timer manually",
    deployed_link: "https://62ea4ac7b2e49d06fa617be9--googlecalculator.netlify.app/",
    github: "https://github.com/Suraj-Badwaik/Google_stopwatch_and_timer_app",
  },
  {
    id: 3,
    category: "React",
    totalLike: "630",
    title: "React calculator with basic functionality",
    image: "https://i.postimg.cc/MpJ5WqTb/Screenshot-2022-08-03-191402.png",
    overview:"This app is a functional react calculator",
    desc : "here you can find increment and descrement button which increment and descrement the main screen number by 1 respectively. Also you can find one small input field at the mid of the calculator where you can input a number which you can add, multiply, substract and divide with the current main screen number by using the four buttons Add, Substract, Multiply and Divide.",
    deployed_link: "https://62ea7b4aaae8b700683e2eca--basicreactcalculator.netlify.app/",
    github: "https://github.com/Suraj-Badwaik/react_calculator",
    
  },
  {
    id: 4,
    category: "JavaScript",
    totalLike: "360",
    title: "Weather Forecaster Application",
    image: "https://i.postimg.cc/MK4mdXwT/2022-04-23-2.png",
    overview:"A weather forecast application designed using advanced JavaScript features",
    desc : "In this app, you can simply enter the location for which you want to see the weather forecast. The app will also predict teh forecaste for the next 7 days.",
    deployed_link: "https://weatherapp-using-api.netlify.app",
    github: "https://github.com/masai-course/suraj_fw17_0321/tree/master/unit-3/sprint-2/day-3/assignments/weatherApp",
  },
  {
    id: 5,
    category: "JavaScript",
    totalLike: "280",
    title: "Youtube Clone",
    image: "https://i.postimg.cc/63wkqYbD/2022-04-24.png",
    overview:"This is a Youtube clone",
    desc : "In this app, you can search for all the videos available on the original youtube application. By default you can see the trending videos of India.",
    deployed_link: "https://youtube-clone-using-api.netlify.app",
    github: "https://github.com/Suraj-Badwaik/youtube-clone",
  },
  {
    id: 5,
    category: "JavaScript",
    totalLike: "280",
    title: "Unsplash Clone",
    image: "https://i.postimg.cc/9fvnw18W/Screenshot-2022-08-07-190955.png",
    overview:"This is a Unsplash clone. Unsplash is a free image web application.",
    desc : "In this app, you can search for the images you want to see like cat, car , etc. You can also sort and filter the search result.",
    deployed_link: "https://ubiquitous-torte-ea5526.netlify.app/",
    github: "https://github.com/masai-course/suraj_fw17_0321/tree/master/unit-3/sprint-4/day-2/assignments/unsplash",
  },

]
export default Portfolio_data
